<template>
    <div class="Item f-12 default-color">
        <headerItem msg="逾期/不良" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
        <div class="d-flex ju-around f-30">
            <div style="width: 100%;" class="item-container d-flex fl-dir-column">
                <div class="item-style flex-1 d-flex item-center ju-between to-right-bototm">
                    <dv-decoration-9 style="width:200px;height:200px;">66%</dv-decoration-9>
                    <div class="flex-1" style="margin-left: 30px;">
                        <div class="d-flex ju-between">
                            <div>逾期金额</div>
                            <div class="hign-white">45567777</div>
                        </div>
                        <div class="d-flex ju-between">
                            <div>逾期总额</div>
                            <div class="hign-white">45777</div>
                        </div>
                    </div>
                </div>
                <div class="item-style flex-1 d-flex item-center ju-between to-right-bototm">
                    <div class="flex-1" style="margin-right: 30px;">
                        <div class="d-flex ju-between">
                            <div>不良余额</div>
                            <div class="hign-white">0</div>
                        </div>
                    </div>
                    <dv-decoration-9 style="width:200px;height:200px;">0</dv-decoration-9>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerItem from '../components/headerItem.vue';
export default {
    name: '',
    components: {
        headerItem
    },
    data() {
        return {
            chart: null
        }
    },
    created() {
        
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.Item {
    height: 100%;

    .item-container {
        .item-style {
            width: 100%;
            height: 240px;
            box-sizing: border-box;
            padding: 10px;
            margin-top: 30px;
            border-radius: 4px;
        }

        .to-right-bototm {
            border: 1px solid rgba(0, 146, 246, .3);
        }
    }
}
.roll-table-header {
  color: #000;
  font-weight: 800;
  font-size: 16px;
}
.roll-table-item {
  color: #000;
  font-size: 15px;
}
</style>

